import BasicList from 'core/modules/components/lists/components/BasicList';
import PropTypes from 'prop-types';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import OptionalCheckboxGroup from 'core/modules/components/lists/components/OptionalCheckboxGroup/OptionalCheckboxGroup';
import UnitItem from '../UnitItem/UnitItem';

const UnitList = ({ t, units, selectedUnits, disableUnits, onChangeSelected, loadMore, hasMore, legend, isLegendHidden }) => {
  const content = (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadMore}
      hasMore={hasMore}
      getScrollParent={() => document.getElementById('dialog-add-unit__list')}
      useWindow={false}
    >
      <BasicList
        items={units.map((unit) => {
          return (
            <div className="unit-list__entry" key={unit.guid}>
              <UnitItem
                t={t}
                isEditorial={true}
                disabled={disableUnits.includes(unit.guid)}
                guid={unit.guid}
                name={unit.name}
                level={unit.level}
                discipline={
                  t('disciplines:' + unit.education_discipline_guid).startsWith('ed-') ? unit.discipline : t('disciplines:' + unit.education_discipline_guid)
                }
                book={unit.book}
                editedbBy={unit.editedbBy}
                selected={selectedUnits.includes(unit.guid)}
                onChangeSelected={onChangeSelected}
              />
            </div>
          );
        })}
      />
    </InfiniteScroll>
  );

  return (
    <OptionalCheckboxGroup className="unit-list" isLegendHidden={isLegendHidden} legend={legend}>
      {content}
    </OptionalCheckboxGroup>
  );
};

UnitList.propTypes = {
  disableUnits: PropTypes.array,
  hasMore: PropTypes.bool,
  isLegendHidden: PropTypes.bool,
  legend: PropTypes.string,
  loadMore: PropTypes.func,
  onChangeSelected: PropTypes.func,
  selectedUnits: PropTypes.array,
  t: PropTypes.func,
  units: PropTypes.array,
};

UnitList.defaultProps = {
  units: [],
  selectedUnits: [],
  hasMore: false,
  loadMore: () => {},
};

export default UnitList;
